import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getPersonas = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/personas?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearPersona = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/personas', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updatePersona = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/personas/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deletePersona = (Id) => Axios.delete(`/personas/${Id}`);